module.exports = __webpack_public_path__ + "img/web-traffic.ad2bd61.jpeg";